import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { formToObject, objectToQueryString, paramsToObject, populateForm, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function CancelamentoContrato(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [diasParametro, setDiasParametro] = useState(0)
  const [selected, setSelected] = useState([])

  const columns = [
    { id: 'pk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
    { id: 'nomecli', numeric: false, label: 'Cliente', align: 'left', minWidth: 200 },
    { id: 'data_cancelamento', numeric: false, label: 'Data Vencimento', align: 'left', minWidth: 50 },
    { id: 'dias_atraso', numeric: false, label: 'Dias Atraso', align: 'left', minWidth: 50 },

  ]

  useEffect(() => {
    swal.fire({
      customClass: {
        container: 'my-swal'
      },

      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('parametros/').then(r=>{ 
      swal.close()
      if (r.data[0]){
        setDiasParametro(r.data[0].dias_atraso_cancelamento)
      }
    })
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      

      let tela = 'Contratos'

    

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
 

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      let event = new Event('build');
      getData(event)
        // getData(event)

    }
    diasParametro > 0 && fetchData()
  }, [diasParametro])

  function cancelarContratos(e) {
    e.preventDefault()
    if (selected.length == 0){
      return swal.fire('Selecione os contratos.', "Obrigatório selecionar no minimo um contrato!", "error")
    } 
    api.post('contratos/cancelamento', {selected: selected}).then(r => {
      if (r.data=='done'){
        swal.fire('Contratos cancelados!', 'Procedimento realizado com sucesso', 'success').then(() => {
          let event = new Event('build');
          getData(event)

        })
      } else {
        swal.fire('Erro!', 'Falha ao cancel os contratos. Tente novamente', 'error').then(() => {
          let event = new Event('build');
          getData(event)

        })
      }
    })
  }

  function getData(e) {
    e.preventDefault()
    try {
      var formData = new FormData(document.getElementById('searchForm'))
      var queryObject = formToObject(formData)
      queryObject.buscar = true
      queryObject.cancelados = diasParametro

      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/cancelamento_contrato?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      

      api.get('/usuarios/pegaSedes?pk_usu=' + getUserCode()).then(r => {
        let sedes = ''
        if (r.data[0]) {
          sedes = r.data[0].sedes
          queryObject.sedes = sedes
        }

        api.get('/contratos', { params: queryObject }).then(r => {
          setData(r.data)
          swal.close()
        })
      })
      
    } catch (error) {
      window.location.reload()
    }

  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/cancelamento_contrato');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };


  function chamaRegistro(e) {
    e.preventDefault();
    window.location.href = "/salute/cancelamento_contrato/registro"

  }


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Contratos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              

            </div>
            <div>
              <button onClick={cancelarContratos} disabled={selected.length == 0}>
                <Icon icon={ic_delete} size={18} />
                Cancelar Contratos
              </button>
              
             
              
            </div>
          </form>
        </div>

        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable
            startOrder='desc'
            startOrderBy='pk_cto'
            regName="contratos"
            frame={props.frame}
            columns={columns}
            searched={filtered}
            codeName="pk_cto"
            mostraCheck={"S"}
            page={'contratos'}
            data={data}
            selected={selected}
            setSelected={setSelected}
            readOnly
            enableDel={false}
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default CancelamentoContrato;